//#region  Framework modules
import { BrowserModule, Title, Meta } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { StoreModule } from "@ngrx/store";

import { userReducer } from "./store/user/user.reducer";
//#endregion

//#region Application modules
// import { IconsModule } from "./shared/modules/icons.module";
import { PublicModule } from "./public/public.module";
import { AppRoutingModule } from "./app-routing.module";
import { NgxSpinnerModule } from "ngx-spinner";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
//#endregion

//#region Application components
import { AppComponent } from "./app.component";
import { UploaderComponent } from "./shared/components/uploader/uploader.component";
import { MessagesComponent } from "./shared/components/messages/messages.component";
import { PageNotFoundComponent } from "./public/page-not-found/page-not-found.component";
//#endregion

//#region Application services
import { AuthService } from "./core-services/auth.service";
import { HttpErrorHandler } from "./core-services/http-error-handler.service";
import { MessageService } from "./core-services/message.service";
import { httpInterceptorProviders } from "./http-interceptors";
import UserState from "./store/user/user.types";
import { environment } from '../environments/environment';
import { CookieService } from "ngx-cookie-service";
import { EnquirySidebarComponent } from "./public/enquiry-sidebar/enquiry-sidebar.component";
import { EnquirySidebarService } from "./public/enquiry-sidebar/service/enquiry-sidebar.service";

//#endregion
/*
 * Note on state managment:
 * You need to include all the components that use the state in the declarations.
 */
// Components to listen to store

export interface AppState {
  user: UserState;
}

@NgModule({
  declarations: [
    AppComponent,
    MessagesComponent,
    UploaderComponent,
    PageNotFoundComponent
    // Store
    // LoginModalComponent
  ],
  imports: [
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    NgxSpinnerModule,
    PublicModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    EnquirySidebarComponent   
  ],
  providers: [
    AuthService,
    HttpErrorHandler,
    MessageService,
    httpInterceptorProviders,
    Title,
    Meta,
    CookieService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
